import React, { useRef, useState } from "react";
import { Camera, Loader2, UserCircle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";

const fileToResizedDataUrl = (file, max = 256) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, max / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const FotoPerfilCard = () => {
  const { auth, trocarFoto } = useApp();
  const { toast } = useToast();
  const [saving, setSaving] = useState(false);
  const [preview, setPreview] = useState(auth?.foto || "");
  const ref = useRef(null);
  const nome = auth?.nome || "";
  const iniciais = nome.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

  const escolher = async (e) => {
    const file = e.target.files?.[0];
    if (ref.current) ref.current.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { toast({ title: "Selecione uma imagem" }); return; }
    setSaving(true);
    try {
      const dataUrl = await fileToResizedDataUrl(file);
      await trocarFoto(dataUrl);
      setPreview(dataUrl);
      toast({ title: "Foto atualizada" });
    } catch (err) {
      toast({ title: "Não foi possível atualizar a foto" });
    } finally { setSaving(false); }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5" data-testid="foto-perfil-card">
      <h2 className="font-semibold text-slate-800 flex items-center gap-2 mb-4">
        <UserCircle className="w-4 h-4 text-blue-600" /> Foto de perfil
      </h2>
      <div className="flex items-center gap-4">
        {preview
          ? <img src={preview} alt="foto de perfil" className="w-20 h-20 rounded-2xl object-cover border border-slate-100" data-testid="foto-perfil-preview" />
          : <div className="w-20 h-20 rounded-2xl bg-blue-600 text-white flex items-center justify-center text-xl font-semibold">{iniciais || "?"}</div>}
        <div className="space-y-2">
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={escolher} data-testid="foto-perfil-input" />
          <Button type="button" onClick={() => ref.current?.click()} disabled={saving} className="bg-blue-600 hover:bg-blue-700 gap-2" data-testid="foto-perfil-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />} {saving ? "Enviando..." : "Trocar foto"}
          </Button>
          <p className="text-xs text-slate-400">JPG ou PNG. A imagem é redimensionada automaticamente.</p>
        </div>
      </div>
    </div>
  );
};

export default FotoPerfilCard;
